
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiDisplayBrillianceIec as ObiDisplayBrillianceIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-display-brilliance-iec.js';
 
 
 

 
 export const ObiDisplayBrillianceIec = createComponent({
   react: React,
   tagName: 'obi-display-brilliance-iec',
   elementClass: ObiDisplayBrillianceIecElement,
   events: {
     
   }
  });
 
 